export const floorOptions: { id: string; label: string }[] = [
  { id: '1_kai', label: '1階' },
  { id: '2_kai', label: '2階' },
  { id: '3_kai', label: '3階' },
  { id: '1_kai_yuka', label: '1階床' },
  { id: '2_kai_yuka', label: '2階床' },
  { id: '3_kai_yuka', label: '3階床' },
  { id: '1_kai_koya', label: '1階小屋' },
  { id: '2_kai_koya', label: '2階小屋' },
  { id: '3_kai_koya', label: '3階小屋' },
  { id: 'others', label: 'その他' }
];
